// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3jqmc","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1OUyA"};